const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/promotions/$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import * as React from "react";
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/promotions/$id")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ({
    context: _context,
    params
  }) => {
    throw redirect({
      to: "/{-$locale}/tags/$id",
      params: {
        id: params.id
      }
    });
  }
});